import { css } from '@emotion/css'
import { fontWeight, spacing, fontSize, shorthandHelper, textStyles, colors } from '@offerzen/pinata'

const styles = {
  currencyInput: css({
    width: '100%',
    '& input': {
      border: 0,
      padding: `${shorthandHelper([spacing.small, spacing.small, spacing.small, 42])} !important`,
      height: '100% !important',
    },
  }),

  preferredSalary: css({
    marginBottom: spacing.large,
    fontWeight: fontWeight.medium,
    legend: {
      color: colors.blackPearl,
    },
  }),

  text: css({
    ...textStyles,
    marginBottom: spacing.medium,
  }),

  notification: css({
    marginBottom: spacing.large,
  }),

  formFieldset: css({
    marginBottom: spacing.large,

    '> legend': {
      fontWeight: fontWeight.medium,
      fontSize: fontSize.medium,
      marginBottom: spacing.medium,
    },
  }),

  footer: css({
    marginTop: spacing.default,
  }),
}

export default styles
